export const BACKOFFICE_MOVEMENT_TABLE_HEADERS = [
  {
    text: 'Atribuído a',
    value: 'responsibleUserId',
    class: 'text--truncate',
    sortable: false,
    style: 'min-width: 150px; white-space: nowrap',
  },
  {
    text: 'Estrutura de Atendimento',
    value: 'structureName',
    class: 'text--truncate',
    sortable: false,
  },
];

export const insertBackofficeHeadersBeforeStatus = (headers, isRHProtegido) => {
  if (isRHProtegido) return headers;

  const statusIndex = headers.findIndex((header) => header.value === 'status');
  if (statusIndex === -1) {
    return [...headers, ...BACKOFFICE_MOVEMENT_TABLE_HEADERS];
  }

  return [
    ...headers.slice(0, statusIndex),
    ...BACKOFFICE_MOVEMENT_TABLE_HEADERS,
    ...headers.slice(statusIndex),
  ];
};

export const insertBackofficeDependentPaddingHeaders = (headersDependents, isRHProtegido) => {
  if (isRHProtegido) return headersDependents;

  const statusIndex = headersDependents.findIndex((header) => header.value === 'status');
  if (statusIndex === -1) return headersDependents;

  return [
    ...headersDependents.slice(0, statusIndex),
    { text: '' },
    { text: '' },
    ...headersDependents.slice(statusIndex),
  ];
};

export const resolveResponsibleUserDisplay = (item, formatter) => {
  if (!item) return '';

  const name = item.responsible_user_name ?? item.responsibleUserName;
  const id = item.responsible_user_id ?? item.responsibleUserId;
  const hasId = id !== null && id !== undefined && id !== '';
  const hasName = name !== null && name !== undefined && String(name).trim() !== '';

  if (!hasId && !hasName) return '';

  if (hasName) {
    return formatter
      ? formatter.formatToTitleCase(String(name))
      : String(name);
  }

  return String(id);
};

export const hasResponsibleUser = (item) => {
  if (!item) return false;

  const id = item.assignedTo ?? item.responsible_user_id ?? item.responsibleUserId;
  const name = item.assignedToName ?? item.responsible_user_name ?? item.responsibleUserName;
  const hasId = id !== null && id !== undefined && id !== '';
  const hasName = name !== null && name !== undefined && String(name).trim() !== '';

  return hasId || hasName;
};

export const resolveStructureNameDisplay = (item) => {
  if (!item) return '';

  const value = item.structure_name ?? item.structureName;
  if (value === null || value === undefined || String(value).trim() === '') return '';

  return String(value);
};
